import React from 'react';
import Location from './Location';
import Social from './Social';
import Facebook from '../../images/facebook.svg';
import Twitter from '../../images/twitter.svg';
import translate from 'i18n/translate';
import flagEU from '../../images/eu-flag.png';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer-container pt-4 pb-4">
      <div className="footer-container-box">
        <Link className="link" to="/contact">
          <Location zoom={17} title={true}></Location>
        </Link>
      </div>
      <div className="footer-container-box d-flex justify-content-center">
        <div>
          <h4 className="mb-4 text-uppercase">{translate('contact')}</h4>
          <p className="contact-name">+ 381 (0)21 844 - 923</p>
          <p className="contact-name">+ 381 (0)63 75-58-305 </p>
          <p className="contact-name">e-mail:office@vmc.rs</p>
          <div className="social-container mt-5 d-flex justify-content-around align-items-center">
            <Social
              icon={Facebook}
              url="https://www.facebook.com/vmc.klaster"
            ></Social>
            <Social
              icon={Twitter}
              url="https://twitter.com/VMCKlaster"
            ></Social>
          </div>
        </div>
      </div>
      <div className="footer-container-box d-flex justify-content-around flex-column">
        <h4 style={{ color: 'white' }} className="text-uppercase mb-3">
          Powered By
        </h4>
        <div style={{ height: '200px', textAlign: 'center' }}>
          <img className="eu-flag" src={flagEU} alt="flag-eu"></img>
        </div>
      </div>
    </footer>
  );
}
